import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth, TextWidthExtended } from '@ta-interaktiv/react-disco-grid'
import GaugeWithTitle from 'components/GaugeWithTitle'
const NEEDLE_DATA_URL =
  'https://storage.googleapis.com/ta-interaktiv/energy-dashboard/needles.json'
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  interface GaugeData {
    electricity: ResourceMetaData
    gas: ResourceMetaData
    Strom_Wahrscheinlichkeit: number
    Erdgas_Wahrscheinlichkeit: number
  }

  interface ResourceMetaData {
    level: number
    valid_from: string
    'titel@de': string
    'titel@fr': string
    'titel@it': string
    'titel@en': string
    'beschreibung@de': string
    'beschreibung@fr': string
    'beschreibung@it': string
    'beschreibung@en': string
  }
  const [gaugeData, setGaugeData] = useState<GaugeData>()
  useEffect(() => {
    // fetch data from google cloud storage
    fetch(NEEDLE_DATA_URL).then((response) => {
      response.json().then((data) => {
        setGaugeData(data)
      })
    })
  }, [])
  const gauges = [
    {
      category: 'electricity',
      value: gaugeData?.Strom_Wahrscheinlichkeit,
      backgroundColor: 'var(--strom)',
      lead: gaugeData?.electricity['titel@'+tenant?.lang as "titel@de" | "titel@fr"],
      customTitle: properties?.electricity_title
        ? properties?.electricity_title
        : null,
      customLead: properties?.electricity_lead
        ? properties?.electricity_lead
        : null,
      Icon: () => (
        <svg
          width='14'
          height='25'
          viewBox='0 0 14 25'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.569652 12.4296L5.30215 0.825354C5.40971 0.608451 5.62482 0.5 5.73238 0.5H11.7556C12.0782 0.5 12.2933 0.933805 12.1858 1.25916L8.85153 9.93525H12.9387C13.3689 9.93525 13.6916 10.4775 13.3689 10.8029L3.25857 24.2508C2.82835 24.7931 2.183 24.3593 2.29056 23.817L5.40971 13.0803H0.999879C0.677209 13.0803 0.354538 12.755 0.569652 12.4296V12.4296Z'
            fill='currentColor'
          />
        </svg>
      ),
    },
    {
      category: 'gas',
      value: gaugeData?.Erdgas_Wahrscheinlichkeit,
      backgroundColor: 'var(--gas)',
      lead: gaugeData?.gas['titel@'+tenant?.lang as "titel@de" | "titel@fr"],
      customTitle: properties?.gas_title ? properties?.gas_title : null,
      customLead: properties?.gas_lead ? properties?.gas_lead : null,
      Icon: () => (
        <svg
          width='18'
          height='24'
          viewBox='0 0 18 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M17.9921 15.1101C17.9921 20.0198 13.9644 24 8.99607 24C4.02777 24 0 20.0198 0 15.1101C0 13.7733 0.782021 11.637 3.52707 10.2288C0.816916 20.5787 13.9484 19.2657 7.07659 12C2.2292 6.87436 5.94346 1.80593 8.99607 0C8.17835 5.02807 18.3216 6.01283 17.9921 15.1101V15.1101Z'
            fill='currentColor'
          />
        </svg>
      ),
    },
  ]
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <TextWidthExtended>
        <Gauges>
          {gauges.map((gauge) => {
            return (
              <GaugeWithTitle
                Icon={gauge.Icon}
                backgroundColor={gauge.backgroundColor}
                category={gauge.category as 'gas' | 'electricity'}
                value={gauge.value}
                lang={tenant?.lang}
                key={gauge.category}
                lead={gauge?.lead || ''}
                customTitle={gauge.customTitle}
                customLead={gauge.customLead}
              />
            )
          })}
        </Gauges>
      </TextWidthExtended>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 2.6rem;
  margin-bottom: 2rem;
  @media (max-width: 375px) {
    font-size: 1.2rem;
    line-height: 2rem;
  }
`
const Gauges = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 1em;
  justify-content: center;
  width: 100%;
`
export default MainComponent
